import ServiceLocator from "../../global/service-locator";
import {initCoachInfo} from "../../components/coach-info";

export default class CoachesSection {
    constructor() {
        this.sl = ServiceLocator.instance;

        this.init();
    }

    init() {
        const $modal = document.getElementById('modal-coach-info');

        if (!$modal) {
            throw new Error('Coaches section: coach info modal does not exist.');
        }

        const $coachCards = document.querySelectorAll('.coach-card');
        const $showMore = document.getElementById('coachesShowMore');
        const $container = document.getElementById('coachesContainer');

        if (!$coachCards.length) {
            throw new Error('There must be at least one coach card.');
        }

        this.sl.modalService.register('coach-info', Array.from($coachCards), {
            beforeOpen: ($trigger) => {
                initCoachInfo($trigger.closest('.coach-card'));
            }
        });

        if ($showMore) {
            $showMore.addEventListener('click', () => {
                $container.classList.add('-show');
                $showMore.remove();
            });
        }
    }
}